module.exports = __webpack_public_path__ + "static/media/covid-19-site-template-shot-1.fcdceb98.png";